import { toast } from "react-toastify";
import { request } from "../../config/helpers/axios-instance"
import MutlipleAddressPrint from "../address-print/multipleAddressPrint";
import React from "react";
import moment from "moment";
import { MdModeEditOutline } from "react-icons/md";

async function fetchAddress(addressId, orderId) {
    const [addressRes, orderRes] = await Promise.all([
        request({ url: `/address/admin?id=${addressId}`, method: "GET" }),
        request({ url: `userOrder/admin/orderDetails/${orderId}`, method: "GET" }),
    ]);
    const bill_no = orderRes?.data?.data?.additionalDetails?.billNumber ?? null;
    return { address: addressRes.data.data.rows[0], orderId, bill_no }
}

export async function printMultipleAddress(selectedRows, AddopenModal) {
    const addresses = await Promise.all(
        selectedRows.map((row) => {
            return fetchAddress(row.addressId, row.orderId)
        })
    )
    AddopenModal(() => MutlipleAddressPrint({ addresses, selectedRows }));
}
export const isRowSelected = (row, selectedRows) => {
    let preSelectedRows = [...selectedRows];
    for (let index = 0; index < selectedRows.length; index++) {
        const element = preSelectedRows[index];
        if (element.orderId === row.original.id) {
            return index
        }
    }
    return null;
}


const updateOrderStatus = (value, orderId) => {
    return request({
        method: "PUT",
        url: `/userOrder/admin/id/${orderId}`,
        data: {
            status: value
        }
    })
}

export const markAllAsDelivered = async (selectedRows, rows, setSelectedRows, refetchOrders) => {
    let promises = [];
    selectedRows.map((row) => {
        let status = rows.filter((data) => { return row.orderId === data.original.id })[0];
        status = status?.original?.status;
        if (status != 'DELIVERED') {
            return promises.push(updateOrderStatus('DELIVERED', row.orderId))
        }
    })
    try {
        await Promise.all(
            promises
        )
        toast.success('updated status');
        refetchOrders()
        setSelectedRows([])
    } catch (error) {
        toast.error('Error in updating status')
        console.log(error,)
    }

}


export const markAllAsShipInTransit = async (selectedRows, rows, setSelectedRows, refetchOrders) => {
    let promises = [];
    selectedRows.map((row) => {
        let status = rows.filter((data) => { return row.orderId === data.original.id })[0];
        status = status?.original?.status;
        if (status !== 'DELIVERED' && status !== 'SHIPPED_IN_TRANSIT')
            promises.push(updateOrderStatus('SHIPPED_IN_TRANSIT', row.orderId))
    })
    try {
        await Promise.all(
            promises
        )
        toast.success('updated status');
        refetchOrders()
        setSelectedRows([])
    } catch (error) {
        console.log(error)
        toast.error('Error in updating status')
    }
}

export const isInDelhi = (pincode) => {
    if (parseInt(pincode) >= 110001 && parseInt(pincode) <= 110110) {
        return true
    }
    return false
}



/** Ordering user from `mapUserPatient.User` (caregiver). */
export const renderCaregiverColumn = (row, onEditMapping, disableMappingEdit = false) => {
    const u = row.original?.mapUserPatient?.User;
    const mapUserPatient = row.original?.mapUserPatient;
    const canEditMapping = typeof onEditMapping === 'function' && mapUserPatient?.User && mapUserPatient?.Patient;

    return (
        <div className="text-sm font-sans leading-tight flex items-start justify-between gap-2">
            <div>
                {!u?.name && !u?.contact_no ? (
                    <span className="text-gray-400 text-sm">—</span>
                ) : (
                    <>
                        <div className={`font-medium ${row.original.consentDetails ? 'underline' : ''}`}>{u.name || '—'}</div>
                        {u.contact_no ? (
                            <div className="text-elm-500">{u.contact_no}</div>
                        ) : null}
                    </>
                )}
            </div>
            {canEditMapping && (
                <button
                    type="button"
                    disabled={disableMappingEdit}
                    className={`text-gray-500 p-1 rounded-md border border-gray-200 bg-white-50 ${disableMappingEdit ? "opacity-50 cursor-not-allowed" : "hover:text-elm-500"}`}
                    title={disableMappingEdit ? "Editing user-patient mapping is disabled for this tenant" : "Edit user-patient mapping"}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (disableMappingEdit) return;
                        onEditMapping(row.original);
                    }}
                >
                    <MdModeEditOutline className="text-base" />
                </button>
            )}
        </div>
    );
};

export const renderNameColumn = (row) => {
    const p = row.original?.mapUserPatient?.Patient;
    if (!p) {
        return (
            <div className="flex flex-row gap-2 items-center">
                <div title={!row.original.address ? 'Address not present' : isInDelhi(row.original.address.pincode) ? 'Delhi' : 'Out of delhi'} className={`rounded-[50%] h-3 w-3 ${!row.original.address ? 'bg-purple-600' : isInDelhi(row.original.address.pincode) ? ' bg-green-500' : ' bg-red-500'}`} />
                <span className="text-gray-400 text-sm">—</span>
            </div>
        );
    }
    return <div className="flex flex-row gap-2 items-center">
        <div title={!row.original.address ? 'Address not present' : isInDelhi(row.original.address.pincode) ? 'Delhi' : 'Out of delhi'} className={`rounded-[50%] h-3 w-3 ${!row.original.address ? 'bg-purple-600' : isInDelhi(row.original.address.pincode) ? ' bg-green-500' : ' bg-red-500'}`}></div>
        <h1>
            <b className={`text-lg ${row.original.consentDetails ? 'underline' : ''}`}>
                {p?.name} ({moment().diff(p?.dob, 'years')}{p?.gender}):
                &nbsp;
            </b>
            <span className="text-elm-500 text-lg">
                {p?.contact_no}
            </span>
            <div>
                <span className="text-black text-[12px] font-bold">
                    Date: {moment(row.original.createdAt).format("DD/MM/YY")}
                </span>
            </div>
        </h1>
    </div >
}

export const renderCityColumn = (row) => {
    const p = row.original?.mapUserPatient?.Patient;
    return <div className="flex flex-row gap-2 items-center">
        <div title={!row.original.address ? 'Address not present' : isInDelhi(row.original.address.pincode) ? 'Delhi' : 'Out of delhi'} className={`rounded-[50%] h-3 w-3 ${!row.original.address ? 'bg-purple-600' : isInDelhi(row.original.address.pincode) ? ' bg-green-500' : ' bg-red-500'}`}></div>
        <h1>
            <b className={`text-lg ${row.original.consentDetails ? 'underline' : ''}`}>
                {p?.name} ({moment().diff(p?.dob, 'years')}{p?.gender}):
                &nbsp;
            </b>
            <span className="text-elm-500 text-lg">
                {p?.contact_no}
            </span>
        </h1>
    </div >
}
